/* ============================================================
   MAD KEEN FISHING — THEME JS v3
   ============================================================ */

var MK = MK || {};

/* ─── SCROLL LOCK (stacking-safe) ─── */
MK._scrollLockCount = 0;
MK.lockScroll = function() {
  MK._scrollLockCount++;
  document.body.style.overflow = 'hidden';
};
MK.unlockScroll = function() {
  MK._scrollLockCount = Math.max(0, MK._scrollLockCount - 1);
  if (MK._scrollLockCount === 0) document.body.style.overflow = '';
};

/* ─── CART ─── */
MK.addToCart = function(variantId, btn, qty) {
  var quantity = qty || 1;
  var origText = btn ? btn.textContent : '';
  if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ id: variantId, quantity: quantity })
  })
  .then(function(r) { return r.ok ? r.json() : r.json().then(function(e) { throw e; }); })
  .then(function() {
    if (btn) { btn.textContent = origText; btn.disabled = false; }
    MK.cartDrawer.open();
  })
  .catch(function(err) {
    if (btn) { btn.textContent = origText; btn.disabled = false; }
    var msg = (err && err.description) ? err.description : 'Something went wrong — please try again.';
    MK.cartDrawer._toast(msg);
  });
};

/* ─── CART GIFTS ─── */
MK.cartGifts = {
  _syncing: false,
  _pendingSync: false,  // queued re-sync waiting for current to finish
  _syncTimer: null,     // auto-reset handle in case _syncing gets stuck
  _failedGifts: {},     // variantId → true when an add was rejected (e.g. out of stock)

  getData: function() {
    var el = document.getElementById('cart-gifts-data');
    if (!el || el.dataset.enabled === 'false') return null;
    var tiers = [];
    [1, 2, 3].forEach(function(i) {
      var threshold = parseInt(el.dataset['tier' + i + 'Threshold']) || 0;
      var variantId = (el.dataset['tier' + i + 'VariantOverride'] || '').trim() ||
                      (el.dataset['tier' + i + 'Variant'] || '').trim();
      var name = el.dataset['tier' + i + 'Name'] || '';
      var image = el.dataset['tier' + i + 'Image'] || '';
      if (threshold > 0) {
        tiers.push({ threshold: threshold, variantId: variantId || null, name: name, image: image });
      }
    });
    return tiers;
  },

  nonGiftTotal: function(cart, tiers) {
    // Only exclude items that were actually added as free gifts (have _free_gift property)
    return cart.items.reduce(function(sum, item) {
      var props = item.properties || {};
      if (props['_free_gift'] || props._free_gift) return sum;
      return sum + (item.final_line_price || 0);
    }, 0);
  },

  sync: function(cart, tiers) {
    if (MK.cartGifts._syncing) {
      MK.cartGifts._pendingSync = true;
      return Promise.resolve(false);
    }

    var total = MK.cartGifts.nonGiftTotal(cart, tiers);
    var configuredIds = tiers.map(function(t) { return String(t.variantId); }).filter(Boolean);

    // Build batched remove list (keyed by line item key → qty 0)
    var removeUpdates = {};
    cart.items.forEach(function(item) {
      var props = item.properties || {};
      if (!(props['_free_gift'] || props._free_gift)) return;
      var vid = String(item.variant_id);
      // Remove stale (not in configured tiers) or no-longer-qualifying gifts
      var tier = tiers.find(function(t) { return String(t.variantId) === vid; });
      if (!tier || total < tier.threshold) {
        removeUpdates[item.key] = 0;
      }
    });

    // Build batched add list (items array for cart/add.js)
    var addItems = [];
    tiers.forEach(function(tier) {
      if (!tier.variantId) return;
      var unlocked = total >= tier.threshold;
      if (!unlocked) return;
      // Check if already in cart (tagged or untagged)
      var alreadyIn = cart.items.some(function(item) {
        return String(item.variant_id) === String(tier.variantId);
      });
      if (!alreadyIn) {
        addItems.push({ id: String(tier.variantId), quantity: 1, properties: { _free_gift: 'true' } });
      }
    });

    var hasRemovals = Object.keys(removeUpdates).length > 0;
    var hasAdds = addItems.length > 0;
    if (!hasRemovals && !hasAdds) return Promise.resolve(false);

    MK.cartGifts._syncing = true;
    MK.cartGifts._syncTimer = setTimeout(function() {
      MK.cartGifts._syncing = false;
      MK.cartGifts._pendingSync = false;
    }, 15000);

    // Cart writes are chained (never concurrent — Shopify's cart can't handle
    // parallel writes; they race and silently clobber each other). Remove first,
    // then add gifts in ONE atomic bulk request. Bulk is critical for speed:
    // every /cart write reprocesses the gift discount (~1.5–2s), so three
    // SEQUENTIAL adds took ~4.5s and left the drawer showing "Adding…" long
    // enough to look stuck. One bulk add = one write = ~2s for all gifts.
    var chain = Promise.resolve();

    if (hasRemovals) {
      chain = chain.then(function() {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: removeUpdates })
        }).then(function(r) { return r.json(); }).catch(function() {});
      });
    }

    if (hasAdds) {
      chain = chain.then(function() {
        // Fast path: add every gift in a single atomic bulk request.
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: addItems })
        }).then(function(r) {
          if (r.ok) {
            addItems.forEach(function(g) { delete MK.cartGifts._failedGifts[String(g.id)]; });
            return r.json();
          }
          // Bulk is all-or-nothing — if one gift is unavailable the whole batch
          // fails. Fall back to sequential per-gift adds so the available gifts
          // still land and only the genuinely unavailable one is flagged.
          return addItems.reduce(function(seq, gift) {
            return seq.then(function() {
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(gift)
              }).then(function(rr) {
                if (!rr.ok) { MK.cartGifts._failedGifts[String(gift.id)] = true; }
                else { delete MK.cartGifts._failedGifts[String(gift.id)]; }
              }).catch(function() {});
            });
          }, Promise.resolve());
        }).catch(function() {});
      });
    }

    return chain.then(function() {
      clearTimeout(MK.cartGifts._syncTimer);
      MK.cartGifts._syncing = false;
      var hadPending = MK.cartGifts._pendingSync;
      MK.cartGifts._pendingSync = false;
      return hadPending ? 'pending' : true;
    }).catch(function() {
      clearTimeout(MK.cartGifts._syncTimer);
      MK.cartGifts._syncing = false;
      MK.cartGifts._pendingSync = false;
      return false;
    });
  },

  render: function(cart, tiers) {
    if (!tiers || !tiers.length) return '';
    var configuredTiers = tiers.filter(function(t){ return !!t.variantId; });
    var total = MK.cartGifts.nonGiftTotal(cart, configuredTiers);
    var highestUnlocked = -1;
    tiers.forEach(function(t, i) { if (total >= t.threshold) highestUnlocked = i; });
    var allDone = highestUnlocked === tiers.length - 1;

    // Progress bar fill %
    var pct = 0;
    if (allDone) {
      pct = 100;
    } else if (highestUnlocked >= 0) {
      var next = tiers[highestUnlocked + 1].threshold;
      var prev = tiers[highestUnlocked].threshold;
      var segPct = (highestUnlocked / (tiers.length - 1)) * 100;
      var segSize = 100 / (tiers.length - 1);
      pct = segPct + ((total - prev) / (next - prev)) * segSize;
    } else {
      pct = (total / tiers[0].threshold) * (100 / (tiers.length - 1 || 1));
    }
    pct = Math.max(0, Math.min(100, pct));

    var giftIcon = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>';
    var checkIcon = '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>';

    // Header
    var html = '<div class="cd-gifts">' +
      '<div class="cd-gifts-header">' +
      '<div class="cd-gifts-title">' + giftIcon + ' Free Gifts</div>' +
      (allDone ? '<div class="cd-gifts-done-badge">🎉 All unlocked!</div>' : '') +
      '</div>';

    // Track: rail on top, nodes row below
    html += '<div class="cd-gifts-track">' +
      '<div class="cd-gifts-rail"><div class="cd-gifts-fill" style="width:' + pct + '%"></div></div>' +
      '<div class="cd-gifts-nodes">';

    tiers.forEach(function(tier, i) {
      var unlocked = total >= tier.threshold;
      var isNext = !unlocked && highestUnlocked === i - 1;
      var cls = 'cd-gift-node' + (unlocked ? ' unlocked' : '') + (isNext ? ' next' : '');
      var imgContent = tier.image
        ? '<img src="' + tier.image + '" alt="" class="cd-gift-img">'
        : '<div class="cd-gift-img-placeholder">🎁</div>';
      var badge = unlocked
        ? '<div class="cd-gift-check">' + checkIcon + '</div>'
        : (isNext ? '<div class="cd-gift-next-tag">NEXT</div>' : '');
      var hasName = tier.name && tier.name.trim();
      var nameHtml = hasName
        ? '<div class="cd-gift-name">' + tier.name + '</div>'
        : '<div class="cd-gift-name is-placeholder">Gift name</div>';

      html += '<div class="' + cls + '">' +
        '<div class="cd-gift-node-img">' + imgContent + badge + '</div>' +
        '<div class="cd-gift-amount">$' + Math.round(tier.threshold / 100) + '</div>' +
        nameHtml +
        '</div>';
    });

    html += '</div></div>'; // close cd-gifts-nodes + cd-gifts-track

    // Nudge
    var nextTier = null;
    tiers.forEach(function(t) { if (!nextTier && total < t.threshold) nextTier = t; });
    if (nextTier) {
      var needed = MK.variants.money(nextTier.threshold - total);
      var nextName = (nextTier.name && nextTier.name.trim()) ? nextTier.name : 'your free gift';
      html += '<div class="cd-gift-nudge">Add <strong>' + needed + ' more</strong> to unlock <strong>' + nextName + '</strong> 🎁</div>';
    }

    html += '</div>';
    return html;
  }
};

/* ─── CART DRAWER ─── */
MK.cartDrawer = {
  open: function() {
    var el = document.getElementById('cart-drawer');
    if (!el) return;
    MK.cartDrawer.refresh();
    el.classList.add('open');
    el.setAttribute('aria-hidden', 'false');
    MK.lockScroll();
    var chat = document.getElementById('shopify-chat');
    if (chat) chat.style.display = 'none';
  },
  close: function() {
    var el = document.getElementById('cart-drawer');
    if (!el) return;
    el.classList.remove('open');
    el.setAttribute('aria-hidden', 'true');
    MK.unlockScroll();
    var chat = document.getElementById('shopify-chat');
    if (chat) chat.style.display = '';
  },
  /* Render drawer contents — separated so refresh() can call it immediately */
  _render: function(freshCart, tiers, itemsEl, footEl) {
          var countEl = document.getElementById('cart-count');
          if (countEl) countEl.textContent = freshCart.item_count || '';

          var giftIds = tiers ? tiers.map(function(t) { return String(t.variantId); }) : [];

          // Optimistic non-gift total — used to decide which gifts to show right now
          var nonGiftTotalNow = tiers ? MK.cartGifts.nonGiftTotal(freshCart, tiers) : freshCart.total_price;

          // Cart is "effectively empty" if every item is a free gift (tagged with _free_gift)
          // Use optimistic total to also treat cart as empty if all paid items were just removed
          var visibleItems = freshCart.items.filter(function(i) {
            var p = i.properties || {};
            var isGift = !!(p['_free_gift'] || p._free_gift);
            if (!isGift) return true;
            // Only show this gift if its tier threshold is still met
            var tier = tiers && tiers.find(function(t) { return String(t.variantId) === String(i.variant_id); });
            return tier ? nonGiftTotalNow >= tier.threshold : true;
          });
          var onlyGifts = freshCart.item_count > 0 && visibleItems.length === 0;
          if (freshCart.item_count === 0 || onlyGifts) {
            var emptyGift = (tiers && tiers.length) ? MK.cartGifts.render(freshCart, tiers) : '';
            itemsEl.innerHTML = emptyGift + '<div class="cd-empty"><svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#d1d5db" stroke-width="1.5"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg><p>Your cart is empty</p><a href="/collections/all" class="btn-primary" onclick="MK.cartDrawer.close()">Shop Now</a></div>';
            if (footEl) footEl.innerHTML = '';
            return;
          }
          var cart = freshCart;
        var html = '';
        visibleItems.forEach(function(item) {
          var imgSrc = item.image ? item.image.replace(/(\.[^.]+)$/, '_200x200$1') : '';
          var variant = (item.variant_title && item.variant_title !== 'Default Title') ? '<span class="cd-variant">' + item.variant_title + '</span>' : '';
          var itemProps = item.properties || {};
          var isGift = !!(itemProps['_free_gift'] || itemProps._free_gift);
          var linePrice = isGift ? 'FREE' : MK.variants.money(item.final_line_price || item.final_price * item.quantity);
          html += '<div class="cd-item' + (isGift ? ' is-gift' : '') + '">' +
            '<a href="' + item.url + '" class="cd-img-wrap" onclick="MK.cartDrawer.close()">' +
            (imgSrc ? '<img src="' + imgSrc + '" alt="" loading="lazy">' : '') +
            '</a><div class="cd-details">' +
            '<div class="cd-item-top">' +
            '<a href="' + item.url + '" class="cd-name" onclick="MK.cartDrawer.close()">' + item.product_title + '</a>' +
            '</div>' +
            variant +
            (isGift ? '' : '<button class="cd-remove" onclick="MK.cartDrawer.changeQty(\'' + item.key + '\',' + item.quantity + ',-' + item.quantity + ')" aria-label="Remove">Remove</button>') +
            '<div class="cd-bottom"><div class="cd-qty">' +
            (isGift
              ? '<span class="cd-qty-locked">Qty: 1</span>'
              : '<button class="cd-qty-btn" onclick="MK.cartDrawer.changeQty(\'' + item.key + '\',' + item.quantity + ',-1)">−</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button class="cd-qty-btn" onclick="MK.cartDrawer.changeQty(\'' + item.key + '\',' + item.quantity + ',1)">+</button>') +
            '</div><span class="cd-price">' + linePrice + '</span>' +
            '</div></div></div>';
        });
        // Optimistic placeholders for gifts being added in background
        if (tiers && tiers.length) {
          tiers.forEach(function(tier) {
            if (!tier.variantId || nonGiftTotalNow < tier.threshold) return;
            // Skip gifts that were rejected (e.g. out of stock) — don't show a
            // permanent "Adding…" placeholder that can never resolve.
            if (MK.cartGifts._failedGifts[String(tier.variantId)]) return;
            var alreadyVisible = visibleItems.some(function(i) {
              return String(i.variant_id) === String(tier.variantId);
            });
            if (!alreadyVisible) {
              // Gift earned but not in cart yet — show "adding" placeholder
              html += '<div class="cd-item is-gift" style="opacity:.55">' +
                '<div class="cd-details">' +
                '<div class="cd-item-top"><span class="cd-name">🎁 ' + (tier.name || 'Free Gift') + '</span></div>' +
                '<div class="cd-bottom"><div class="cd-qty"><span class="cd-qty-locked">Adding…</span></div>' +
                '<span class="cd-price">FREE</span></div></div></div>';
            }
          });
          html += MK.cartGifts.render(cart, tiers);
        }

        // Trust strip
        html += '<div class="cd-trust">' +
          '<div class="cd-trust-item"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>Secure checkout</div>' +
          '<div class="cd-trust-item"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-3"/></svg>60-day returns</div>' +
          '<div class="cd-trust-item"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="1" y="3" width="15" height="13" rx="1"/><path d="M16 8h4l3 5v3h-7V8z"/><circle cx="5.5" cy="18.5" r="1.5"/><circle cx="18.5" cy="18.5" r="1.5"/></svg>Free Aus shipping $50+</div>' +
          '</div>';

        // Upsell strip
        if (window.__MK_UPSELL_PRODUCTS__ && window.__MK_UPSELL_PRODUCTS__.length) {
          var uHeading = window.__MK_UPSELL_HEADING__ || 'You might also like';
          var uHtml = '<div class="cd-upsell"><div class="cd-upsell-heading">' + uHeading + '</div>';
          window.__MK_UPSELL_PRODUCTS__.forEach(function(p) {
            var uv = p.variants.find(function(vt) { return vt.available; }) || p.variants[0];
            var imgRaw = (p.images && p.images[0]) ? p.images[0].src.split('?')[0] : '';
            var img = imgRaw ? imgRaw.replace(/\.(jpg|jpeg|png|gif|webp)$/i, '_80x80.$1') : '';
            var avail = !!(uv && uv.available);
            var priceCents = uv ? Math.round(parseFloat(uv.price) * 100) : 0;
            uHtml += '<div class="cd-upsell-row">' +
              '<a href="/products/' + p.handle + '" class="cd-upsell-thumb" onclick="MK.cartDrawer.close()">' +
              (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
              '</a><div class="cd-upsell-info">' +
              '<a href="/products/' + p.handle + '" class="cd-upsell-name" onclick="MK.cartDrawer.close()">' + p.title + '</a>' +
              '<div class="cd-upsell-price">' + MK.variants.money(priceCents) + '</div>' +
              '</div>' +
              '<button type="button" class="cd-upsell-btn"' + (avail ? '' : ' disabled') +
              ' onclick="MK.addToCart(' + (uv ? uv.id : 0) + ', this, 1)">' +
              (avail ? '+ Add' : 'Out') + '</button>' +
              '</div>';
          });
          uHtml += '</div>';
          html += uHtml;
        }

        itemsEl.innerHTML = html;
        if (footEl) {
          var nonGiftTotal = tiers ? MK.cartGifts.nonGiftTotal(cart, tiers) : cart.total_price;
          var threshold = 5000;
          var shipHtml = '';
          if (nonGiftTotal >= threshold) {
            shipHtml = '<div class="cd-ship-bar cd-ship-achieved">' +
              '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#16a34a" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>' +
              ' Free shipping unlocked!</div>';
          } else {
            var remaining = threshold - nonGiftTotal;
            var pct = Math.round((nonGiftTotal / threshold) * 100);
            shipHtml = '<div class="cd-ship-bar">' +
              '<div class="cd-ship-top"><span>Free shipping</span><span><strong>' + MK.variants.money(remaining) + '</strong> away</span></div>' +
              '<div class="cd-ship-track"><div class="cd-ship-fill" style="width:' + pct + '%"></div></div>' +
              '</div>';
          }
          footEl.innerHTML = shipHtml +
            '<div class="cd-subtotal"><span>Subtotal <small>( ' + cart.item_count + ' item' + (cart.item_count !== 1 ? 's' : '') + ' )</small></span><strong>' + MK.variants.money(nonGiftTotal) + '</strong></div>' +
            '<a href="/checkout" class="cd-checkout-btn">Checkout — ' + MK.variants.money(nonGiftTotal) + ' →</a>' +
            '<a href="/cart" class="cd-view-cart" onclick="MK.cartDrawer.close()">View full cart</a>';
        }
  },

  refresh: function() {
    var itemsEl = document.getElementById('cart-drawer-items');
    var footEl  = document.getElementById('cart-drawer-foot');
    if (!itemsEl) return;
    itemsEl.innerHTML = '<div class="cd-loading">Loading…</div>';

    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var tiers = MK.cartGifts.getData();

        // Render immediately — no waiting for gift sync
        MK.cartDrawer._render(cart, tiers, itemsEl, footEl);

        // Sync gifts in the background — silently re-render if changed
        MK.cartGifts.sync(cart, tiers || []).then(function(changed) {
          if (!changed) return;
          fetch('/cart.js').then(function(r) { return r.json(); }).then(function(fresh) {
            if (changed === 'pending') {
              MK.cartGifts.sync(fresh, tiers || []).then(function(c2) {
                if (c2) {
                  fetch('/cart.js').then(function(r) { return r.json(); }).then(function(f2) {
                    MK.cartDrawer._render(f2, tiers, itemsEl, footEl);
                  }).catch(function() {});
                } else {
                  MK.cartDrawer._render(fresh, tiers, itemsEl, footEl);
                }
              });
            } else {
              MK.cartDrawer._render(fresh, tiers, itemsEl, footEl);
            }
          }).catch(function() {});
        });
      })
      .catch(function() {
        if (itemsEl) itemsEl.innerHTML = '<div class="cd-loading">Something went wrong — <a href="/cart" style="color:inherit;text-decoration:underline;">view cart</a></div>';
      });
  },

  changeQty: function(key, currentQty, delta) {
    var newQty = Math.max(0, currentQty + delta);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      if (delta > 0) {
        var updated = cart.items && cart.items.find(function(i) { return i.key === key; });
        if (updated && updated.quantity < newQty) {
          MK.cartDrawer._toast('Only ' + updated.quantity + ' in stock');
        }
      }
      MK.cartDrawer.refresh();
    })
    .catch(function() { MK.cartDrawer.refresh(); });
  },
  _toast: function(msg) {
    var t = document.createElement('div');
    t.textContent = msg;
    t.style.cssText = 'position:fixed;bottom:90px;left:50%;transform:translateX(-50%);background:#1c1917;color:#fff;padding:9px 18px;border-radius:8px;font-size:13px;font-weight:500;z-index:99999;pointer-events:none;white-space:nowrap;';
    document.body.appendChild(t);
    setTimeout(function() { t.remove(); }, 2500);
  }
};

/* ─── CART DRAWER UPSELL PRELOAD ─── */
// Fetch upsell products once on page load so they're ready when the drawer opens
(function() {
  if (!window.__MK_UPSELL_HANDLE__) return;
  fetch('/collections/' + window.__MK_UPSELL_HANDLE__ + '/products.json?limit=4')
    .then(function(r) { return r.json(); })
    .then(function(data) { window.__MK_UPSELL_PRODUCTS__ = (data.products || []).slice(0, 4); })
    .catch(function() {});
})();

/* ─── CHECKOUT SYNC GATE ─── */
// Intercept drawer + cart page checkout buttons — sync gifts before navigating
var _checkoutGateActive = false;

// Reset gate flag if browser restores page from bfcache (back-button navigation)
window.addEventListener('pageshow', function(e) {
  if (e.persisted) { _checkoutGateActive = false; }
});

document.addEventListener('click', function(e) {
  var btn = e.target.closest('.cd-checkout-btn, .ck-checkout-btn');
  if (!btn) return;
  if (_checkoutGateActive) { e.preventDefault(); return; } // block double-tap
  e.preventDefault();
  _checkoutGateActive = true;
  var href = btn.getAttribute('href') || '/checkout';
  var origText = btn.textContent;
  btn.textContent = 'Checking cart…';
  btn.setAttribute('disabled', 'disabled'); // visually disable to prevent double-tap

  // Hard deadline — if sync takes > 5s just go to checkout anyway
  var didRedirect = false;
  function goCheckout() {
    if (didRedirect) return;
    didRedirect = true;
    window.location.href = href;
  }
  function restoreBtn() {
    btn.textContent = origText;
    btn.removeAttribute('disabled');
    _checkoutGateActive = false;
  }
  var deadline = setTimeout(goCheckout, 5000);

  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var tiers = MK.cartGifts.getData();
      return tiers ? MK.cartGifts.sync(cart, tiers) : Promise.resolve(false);
    })
    .catch(function() {})
    .then(function() {
      clearTimeout(deadline);
      goCheckout();
    })
    .catch(function() {
      clearTimeout(deadline);
      restoreBtn();
      goCheckout();
    });
});

/* ─── CART PAGE GIFT SYNC ─── */
// Silently sync gifts if customer lands on /cart directly (bypassing the drawer)
if (window.location.pathname === '/cart') {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var tiers = MK.cartGifts.getData();
      if (!tiers || !tiers.length) return;
      MK.cartGifts.sync(cart, tiers).then(function(changed) {
        if (!changed || MK.cartPage._busy) return;
        // Gifts changed on page load — re-render section without full reload
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: {}, sections: 'main' })
        })
        .then(function(r) { return r.json(); })
        .then(function(d) { MK.cartPage._applyHtml(MK.cartPage._getHtml(d)); })
        .catch(function() {});
      });
    })
    .catch(function() {});
}

/* ─── PRODUCT FORM (intercept for cart drawer) ─── */
MK.productForm = {
  init: function() {
    var form = document.getElementById('product-form');
    if (!form) return;
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var variantInput = document.getElementById('variant-id');
      var qtyInput = document.getElementById('qty-input');
      if (!variantInput) return;
      var variantId = parseInt(variantInput.value, 10);
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10)) : 1;
      var btn = document.getElementById('add-to-cart-btn');
      var origText = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }
      var body = { id: variantId, quantity: qty };
      var props = {};
      form.querySelectorAll('[name^="properties["]').forEach(function(el) {
        if (el.value) {
          var k = el.name.replace('properties[', '').replace(']', '');
          props[k] = el.value;
        }
      });
      if (Object.keys(props).length) body.properties = props;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
      .then(function(r) { return r.ok ? r.json() : r.json().then(function(e) { throw e; }); })
      .then(function() {
        if (btn) { btn.textContent = origText; btn.disabled = false; }
        MK.cartDrawer.open();
      })
      .catch(function(err) {
        if (btn) { btn.textContent = origText; btn.disabled = false; }
        var msg = (err && err.description) ? err.description : 'Something went wrong — please try again.';
        MK.cartDrawer._toast(msg);
      });
    });
  }
};

/* ─── CART PAGE QTY ─── */
MK.cartPage = {
  _busy: false,

  /* Apply rendered section HTML from Shopify sections API response */
  _applyHtml: function(html) {
    if (!html) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var newCart = doc.querySelector('.ck-cart');
    var curCart = document.querySelector('.ck-cart');
    if (newCart && curCart) {
      curCart.style.opacity = '';
      curCart.innerHTML = newCart.innerHTML;
      return true;
    }
    return false;
  },

  /* Extract section HTML from Shopify response — handles both response formats */
  _getHtml: function(data) {
    if (!data) return null;
    // Format 1: data.sections.main (cart AJAX endpoints with sections in body)
    if (data.sections && data.sections['main']) return data.sections['main'];
    // Format 2: data.main (GET /cart?sections=main)
    if (data['main']) return data['main'];
    return null;
  },

  /* POST to change.js with sections=main embedded — one round trip */
  _change: function(key, qty) {
    var cartEl = document.querySelector('.ck-cart');
    if (cartEl) cartEl.style.opacity = '0.4';
    MK.cartPage._busy = true;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: 'main' })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      // Update header cart count
      if (data.item_count !== undefined) {
        document.querySelectorAll('.cart-count,[data-cart-count]').forEach(function(el) {
          el.textContent = data.item_count || '';
        });
      }
      var html = MK.cartPage._getHtml(data);
      var ok = MK.cartPage._applyHtml(html);
      if (!ok) { location.reload(); return; }
      MK.cartPage._busy = false;

      // Sync gifts using the fresh cart data returned from change.js
      var tiers = MK.cartGifts.getData();
      if (!tiers || !tiers.length) return;
      MK.cartGifts.sync(data, tiers).then(function(changed) {
        if (!changed) return;
        // Gifts changed — fetch fresh section HTML (gifts now added/removed)
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: {}, sections: 'main' })
        })
        .then(function(r) { return r.json(); })
        .then(function(d) { MK.cartPage._applyHtml(MK.cartPage._getHtml(d)); })
        .catch(function() {});
      });
    })
    .catch(function() { location.reload(); });
  },

  changeQty: function(btn, delta, key) {
    if (MK.cartPage._busy) return;
    var row = btn.closest('.ck-item') || btn.parentNode;
    var input = row.querySelector('.ck-qty-input') || row.querySelector('input[type="number"]');
    if (!input) return;
    var newQty = Math.max(0, parseInt(input.value, 10) + delta);
    input.value = newQty;
    MK.cartPage._change(key, newQty);
  },

  removeItem: function(key) {
    if (MK.cartPage._busy) return;
    MK.cartPage._change(key, 0);
  }
};

/* ─── QUICK ADD (product cards) ─── */
MK.quickAdd = {
  changeQty: function(btn, delta, productId) {
    var input = document.getElementById('qty-' + productId);
    if (!input) return;
    var newVal = Math.max(1, Math.min(99, parseInt(input.value, 10) + delta));
    input.value = newVal;
  },
  getVariants: function(productId) {
    var el = document.getElementById('variants-' + productId);
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch(e) { return []; }
  },
  getSelectedOptions: function(productId) {
    var opts = [];
    document.querySelectorAll('.quick-pills-wrap[data-product="' + productId + '"]').forEach(function(wrap) {
      var selected = wrap.querySelector('.quick-pill.selected, .lens-pill.selected');
      if (selected) opts.push({ pos: parseInt(wrap.dataset.optionPos, 10), value: selected.dataset.value });
    });
    opts.sort(function(a,b){ return a.pos - b.pos; });
    return opts.map(function(o){ return o.value; });
  },
  findVariant: function(variants, selectedOptions) {
    return variants.find(function(v) {
      return v.options.every(function(o, i) { return o === selectedOptions[i]; });
    });
  },
  selectPill: function(pill, productId, optionPos) {
    if (pill.classList.contains('unavailable')) return;
    var wrap = pill.closest('.quick-pills-wrap');
    if (wrap) {
      wrap.querySelectorAll('.quick-pill, .lens-pill').forEach(function(p) { p.classList.remove('selected'); });
      pill.classList.add('selected');
    }
    var variants = MK.quickAdd.getVariants(productId);
    var selectedOptions = MK.quickAdd.getSelectedOptions(productId);
    var match = MK.quickAdd.findVariant(variants, selectedOptions);
    var atcBtn = document.getElementById('atc-' + productId);
    var priceEl = document.getElementById('card-price-' + productId);
    if (match) {
      if (atcBtn) {
        atcBtn.dataset.variant = match.id;
        atcBtn.disabled = !match.available;
        atcBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
      }
      if (priceEl) {
        priceEl.textContent = MK.variants.money(match.price);
        var wasEl = priceEl.parentNode.querySelector('.price-was');
        if (match.compare_at_price && match.compare_at_price > match.price) {
          if (!wasEl) {
            wasEl = document.createElement('span');
            wasEl.className = 'price-was';
            priceEl.parentNode.appendChild(wasEl);
          }
          wasEl.textContent = MK.variants.money(match.compare_at_price);
          wasEl.style.display = '';
        } else if (wasEl) {
          wasEl.style.display = 'none';
        }
      }
    }
    // Update unavailable states for all option groups on this card
    var allWraps = document.querySelectorAll('.quick-pills-wrap[data-product="' + productId + '"]');
    allWraps.forEach(function(w, wIdx) {
      w.querySelectorAll('.quick-pill, .lens-pill').forEach(function(p) {
        var testOptions = selectedOptions.slice();
        testOptions[wIdx] = p.dataset.value;
        var hasAvailable = variants.some(function(v) {
          return v.available && v.options.every(function(o, i) {
            return testOptions[i] === undefined || o === testOptions[i];
          });
        });
        p.classList.toggle('unavailable', !hasAvailable);
      });
    });
  }
};

MK.updateCartCount = function() {
  fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
  .then(function(r) { return r.json(); })
  .then(function(cart) {
    var el = document.getElementById('cart-count');
    if (el) { el.textContent = cart.item_count || ''; }
  });
};

/* ─── CURRENCY ─── */
MK.currency = {
  init: function() {
    var btn = document.getElementById('currency-btn');
    var menu = document.getElementById('currency-dropdown');
    var sel = document.getElementById('currency-sel');
    if (!btn || !menu) return;

    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      var isOpen = !menu.hidden;
      menu.hidden = isOpen;
      btn.setAttribute('aria-expanded', String(!isOpen));
      sel.classList.toggle('open', !isOpen);
    });

    menu.querySelectorAll('.currency-opt').forEach(function(opt) {
      opt.addEventListener('click', function() {
        MK.currency.set(opt.dataset.code);
      });
    });

    document.addEventListener('click', function() {
      if (menu) { menu.hidden = true; }
      if (btn) btn.setAttribute('aria-expanded', 'false');
      if (sel) sel.classList.remove('open');
    });
  },
  set: function(code) {
    var form = document.createElement('form');
    form.method = 'post';
    form.action = '/localization';
    var fields = [
      ['_method', 'put'],
      ['currency_code', code],
      ['return_to', window.location.pathname + window.location.search]
    ];
    var token = document.querySelector('input[name="authenticity_token"]');
    if (token) fields.push(['authenticity_token', token.value]);
    fields.forEach(function(f) {
      var inp = document.createElement('input');
      inp.type = 'hidden'; inp.name = f[0]; inp.value = f[1];
      form.appendChild(inp);
    });
    document.body.appendChild(form);
    form.submit();
  }
};

/* ─── HEADER ─── */
MK.header = {
  init: function() {
    var header = document.getElementById('site-header');
    if (!header) return;
    window.addEventListener('scroll', function() {
      header.classList.toggle('scrolled', window.scrollY > 30);
    }, { passive: true });
  }
};

/* ─── MOBILE NAV ─── */
MK.mobileNav = {
  init: function() {
    var toggle = document.getElementById('mobile-toggle');
    var nav = document.getElementById('mobile-nav');
    var closeBtn = document.getElementById('mobile-nav-close');
    var backdrop = document.getElementById('mobile-nav-backdrop');
    if (!toggle || !nav) return;

    function openNav() {
      nav.classList.add('open');
      toggle.setAttribute('aria-expanded', 'true');
      MK.lockScroll();
    }
    function closeNav() {
      nav.classList.remove('open');
      toggle.setAttribute('aria-expanded', 'false');
      MK.unlockScroll();
    }

    toggle.addEventListener('click', openNav);
    if (closeBtn) closeBtn.addEventListener('click', closeNav);
    if (backdrop) backdrop.addEventListener('click', closeNav);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeNav();
    });

    // Submenu toggles
    nav.querySelectorAll('.mobile-nav-toggle').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var sub = btn.closest('.mobile-nav-item-wrap').nextElementSibling;
        if (!sub || !sub.classList.contains('mobile-nav-sub')) return;
        var isOpen = !sub.hidden;
        sub.hidden = isOpen;
        btn.classList.toggle('open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  }
};

/* ─── SEARCH ─── */
/* Search is handled entirely by the inline script in sections/header.liquid */
MK.search = {
  init: function() {}
};

/* ─── SCROLL TOP ─── */
MK.scrollTop = {
  init: function() {
    var btn = document.getElementById('scroll-top-btn');
    if (!btn) return;
    window.addEventListener('scroll', function() {
      btn.hidden = window.scrollY < 400;
    }, { passive: true });
    btn.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
};

/* ─── PRODUCT VARIANTS ─── */
MK.variants = {
  money: function(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  },
  init: function() {
    if (!window.__PRODUCT_VARIANTS__) return;
    var variants = window.__PRODUCT_VARIANTS__;

    document.querySelectorAll('.option-pill').forEach(function(pill) {
      pill.addEventListener('click', function() {
        if (pill.classList.contains('unavailable')) return;
        pill.closest('.option-pills').querySelectorAll('.option-pill').forEach(function(p) { p.classList.remove('selected'); });
        pill.classList.add('selected');

        var selected = [];
        document.querySelectorAll('.product-option-group').forEach(function(group, i) {
          var active = group.querySelector('.option-pill.selected');
          if (active) {
            selected.push(active.dataset.value);
            var labelEl = document.getElementById('opt-val-' + (i + 1));
            if (labelEl) labelEl.textContent = active.dataset.value;
          }
        });

        var match = variants.find(function(v) {
          return v.options.every(function(o, i) { return o === selected[i]; });
        });
        if (!match) {
          // No variant for this combination — disable ATC so wrong item can't be added
          var noMatchAtc = document.getElementById('add-to-cart-btn');
          if (noMatchAtc) { noMatchAtc.disabled = true; noMatchAtc.textContent = 'Select all options'; }
          var noMatchSticky = document.getElementById('sticky-atc-btn');
          if (noMatchSticky) { noMatchSticky.disabled = true; noMatchSticky.textContent = 'Select all options'; }
          return;
        }

        var varInput = document.getElementById('variant-id');
        if (varInput) varInput.value = match.id;

        var priceEl = document.getElementById('price-main');
        if (priceEl) priceEl.textContent = MK.variants.money(match.price);

        var priceBlock = priceEl ? priceEl.parentNode : null;
        var compareEl = document.getElementById('price-compare');
        var saveEl = priceBlock ? priceBlock.querySelector('.price-save') : null;
        if (match.compare_at_price && match.compare_at_price > match.price) {
          if (!compareEl && priceBlock) {
            compareEl = document.createElement('span');
            compareEl.id = 'price-compare';
            compareEl.className = 'price-compare';
            priceBlock.appendChild(compareEl);
          }
          if (compareEl) { compareEl.textContent = MK.variants.money(match.compare_at_price); compareEl.style.display = ''; }
          if (!saveEl && priceBlock) {
            saveEl = document.createElement('span');
            saveEl.className = 'price-save';
            priceBlock.appendChild(saveEl);
          }
          if (saveEl) { saveEl.textContent = 'Save ' + MK.variants.money(match.compare_at_price - match.price); saveEl.style.display = ''; }
        } else {
          if (compareEl) compareEl.style.display = 'none';
          if (saveEl) saveEl.style.display = 'none';
        }

        var atcBtn = document.getElementById('add-to-cart-btn');
        if (atcBtn) {
          atcBtn.disabled = !match.available;
          atcBtn.textContent = match.available
            ? 'Add to Cart ' + MK.variants.money(match.price)
            : 'Sold Out';
        }

        // Low stock — only show for the selected variant's actual quantity
        var stockEl = document.getElementById('low-stock-msg');
        if (stockEl) {
          stockEl.className = '';
          stockEl.innerHTML = '';
          if (match.inventory_management === 'shopify' && match.available) {
            var qty = match.inventory_quantity;
            if (qty > 0 && qty <= 5) {
              stockEl.className = 'low-stock-msg';
              stockEl.innerHTML = '🔥 Only ' + qty + ' left in this size — order soon!';
            } else if (qty > 5 && qty <= 10) {
              stockEl.className = 'low-stock-msg low-stock-warm';
              stockEl.innerHTML = '⚡ Low stock in this size — ' + qty + ' remaining';
            }
          }
        }

        if (match.featured_image && match.featured_image.src) {
          var mainImg = document.getElementById('product-main-img');
          if (mainImg) {
            mainImg.src = match.featured_image.src.replace(/\.[^.]+$/, function(ext) { return '_900x' + ext; });
          }
        }

        // Back in stock form — show when sold out, hide when available
        var bisWrap = document.getElementById('bis-form-wrap');
        var bisBody = document.getElementById('bis-body');
        if (bisWrap) bisWrap.style.display = match.available ? 'none' : '';
        if (bisBody) bisBody.value = 'Back in stock request for product — Variant: ' + (match.title || 'Default') + ' (ID: ' + match.id + ')';

        // Afterpay installment
        var apBadge = document.getElementById('afterpay-badge');
        var apPrice = document.getElementById('afterpay-price');
        if (apBadge) apBadge.style.display = match.price >= 3500 ? '' : 'none';
        if (apPrice) apPrice.textContent = MK.variants.money(Math.ceil(match.price / 4));

        // Sticky ATC price sync
        var stickyPrice = document.getElementById('sticky-price');
        var stickyBtn = document.getElementById('sticky-atc-btn');
        if (stickyPrice) stickyPrice.textContent = MK.variants.money(match.price);
        if (stickyBtn) {
          stickyBtn.disabled = !match.available;
          stickyBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
        }

        // Update unavailable (crossed-out) state for all option pills
        var allGroups = document.querySelectorAll('.product-option-group');
        allGroups.forEach(function(group, groupIdx) {
          group.querySelectorAll('.option-pill').forEach(function(p) {
            var testOptions = selected.slice();
            testOptions[groupIdx] = p.dataset.value;
            var hasAvailable = variants.some(function(v) {
              return v.available && v.options.every(function(o, i) {
                return testOptions[i] === undefined || o === testOptions[i];
              });
            });
            p.classList.toggle('unavailable', !hasAvailable);
          });
        });
      });
    });
  }
};

/* ─── CART NOTE AUTO-SAVE ─── */
// The cart page checkout link bypasses the form, so the note is never submitted.
// Save it via AJAX on change so it persists into checkout.
document.addEventListener('change', function(e) {
  if (e.target && e.target.id === 'cart-note') {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: e.target.value })
    }).catch(function() {});
  }
});

/* ─── INIT ─── */
document.addEventListener('DOMContentLoaded', function() {
  MK.header.init();
  MK.mobileNav.init();
  MK.search.init();
  MK.scrollTop.init();
  MK.currency.init();
  MK.variants.init();
  MK.productForm.init();
  MK.updateCartCount();
});


/* ─── KLAVIYO POPUP SCROLL-LOCK FIX (added 26 Aug 2026) ─── */
/* Klaviyo adds body.klaviyo-prevent-body-scrolling (overflow:hidden) when its popup
   opens but sometimes fails to remove it on close, freezing page scroll on mobile.
   This releases the lock whenever the popup is dismissed (X, Escape, or backdrop). */
(function(){
  var LOCK = 'klaviyo-prevent-body-scrolling';
  function removeLock(){ document.body.classList.remove(LOCK); }
  function unlockSoon(){ [40,200,500,900].forEach(function(ms){ setTimeout(removeLock, ms); }); }
  function popupGone(){
    var x = document.querySelector('button.klaviyo-close-form');
    return !x || x.offsetParent === null; /* removed from DOM or hidden */
  }
  document.addEventListener('click', function(e){
    var t = e.target;
    if (t && t.closest && t.closest('.klaviyo-close-form,[aria-label="Close dialog"]')){ unlockSoon(); return; }
    if (document.body.classList.contains(LOCK)) setTimeout(function(){ if (popupGone()) removeLock(); }, 400);
  }, true);
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') unlockSoon(); });
})();

;(function(){
  /* ===== MK FREEZE FIX — scroll-lock + stuck-overlay watchdog (cart drawer, mobile nav, Klaviyo) ===== */
  function ready(fn){ if(document.readyState!=='loading'){ fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }
  ready(function(){
    if(!window.MK){ window.MK = {}; }
    /* a closed Klaviyo overlay keeps children with pointer-events:auto that cover the page;
       this rule forces the whole dead subtree to let taps fall through */
    if(!document.getElementById('mk-kl-dead-style')){ var _st=document.createElement('style'); _st.id='mk-kl-dead-style'; _st.textContent='.mk-kl-dead,.mk-kl-dead *{pointer-events:none!important;}'; (document.head||document.documentElement).appendChild(_st); }
    function anyDrawerOpen(){ return !!document.querySelector('#cart-drawer.open, #mobile-nav.open'); }
    function klaviyoOpen(){
      var open = false, els = document.querySelectorAll('[class*="kl-private"]');
      for(var i=0;i<els.length;i++){
        var el = els[i], s = getComputedStyle(el);
        if(s.position !== 'fixed'){ continue; }
        if((parseInt(s.zIndex,10)||0) < 1000){ continue; }
        var r = el.getBoundingClientRect();
        if(r.width < window.innerWidth*0.6 || r.height < window.innerHeight*0.6){ continue; }
        var form = el.querySelector('.klaviyo-form, form');
        var vis = parseFloat(s.opacity) > 0 && s.visibility !== 'hidden' && !!form && getComputedStyle(form).display !== 'none' && form.getBoundingClientRect().height > 10;
        if(vis){ open = true; el.classList.remove('mk-kl-dead'); el.style.pointerEvents = ''; }
        else { el.classList.add('mk-kl-dead'); el.style.pointerEvents = 'none'; }
      }
      return open;
    }
    MK.lockScroll = function(){ document.body.style.overflow = 'hidden'; };
    MK.unlockScroll = function(){ if(!anyDrawerOpen() && !klaviyoOpen()){ document.body.style.overflow = ''; } };
    MK._scrollLockCount = 0;
    function heal(){
      var kl = klaviyoOpen();
      if(!anyDrawerOpen() && !kl){
        if(document.body.classList.contains('klaviyo-prevent-body-scrolling')){ document.body.classList.remove('klaviyo-prevent-body-scrolling'); }
        if(document.body.style.overflow === 'hidden'){ document.body.style.overflow = ''; }
        MK._scrollLockCount = 0;
      }
    }
    ['click','touchend','keyup','visibilitychange'].forEach(function(ev){ document.addEventListener(ev, function(){ setTimeout(heal, 350); }, true); });
    setInterval(heal, 400);
    heal();
  });
})();
